import { createSlice } from "@reduxjs/toolkit";
import { AppApi } from "./api/apis";

const initialState = {
  meData: null,
  allCategoryData: [],
  allProducts: [],
  isLogin: false,
};
export const commonSlice = createSlice({
  name: "commomSlice",
  initialState,
  reducers: {
    getMe: (state, action) => {
      state.meData = action.payload;
    },
    userIsLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    getAllCategory: (state, action) => {
      state.allCategoryData = action.payload;
    },
    signOut: (state, action) => {
      state.meData = null;
    },
    addProducts: (state, action) => {
      let products = [...state.allProducts];
      products.push(action.payload);
      state.allProducts = products;
    },
    deleteProduct: (state, action) => {
      let products = [...state.allProducts];
      products = products.filter((product) => product._id !== action.payload);
      state.allProducts = products;
    },
    deleteAllProducts: (state, action) => {
      state.allProducts = action.payload;
    },
  },
  // extraReducers: (builder) => {
  //   builder.addMatcher(
  //     AppApi.endpoints.getUser.matchFulfilled,
  //     (state, action) => {
  //       state.meData = action.payload.data;
  //     }
  //   );
  // },
});

export const {
  getMe,
  getAllCategory,
  signOut,
  addProducts,
  deleteProduct,
  deleteAllProducts,
  userIsLogin,
} = commonSlice.actions;
export default commonSlice.reducer;
